import { render } from "./AppVersionDialog.vue?vue&type=template&id=45b42fe0&scoped=true&ts=true"
import script from "./AppVersionDialog.vue?vue&type=script&lang=ts"
export * from "./AppVersionDialog.vue?vue&type=script&lang=ts"

import "./AppVersionDialog.vue?vue&type=style&index=0&id=45b42fe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b42fe0"]])

export default __exports__